import { createReducer } from '../utils/reducers';
import { SELECT_FEE, CLOSE_MODAL } from '../actions';

export default createReducer(0, {
    [SELECT_FEE]: (state, action) => {
        return action.id;
    },
    [CLOSE_MODAL]: () => {
        return 0;
    },
});



// WEBPACK FOOTER //
// ./src/reducers/accessFees.js